/**
 * Typen des Healthchecks (§35.2).
 *
 * Die Antwort enthält bewusst keine vertraulichen Details: keine Pfade, keine
 * Umgebungsvariablen, keine Geheimnisse.
 */
export const HEALTH_PATH = '/api/v1/system/health';
//# sourceMappingURL=health.js.map